import React, { useState } from "react";
import api from "../../services/api";
import { useAuth } from "../../context/AuthContext";
import { Button, Card, Field, Input } from "../ui";

/** Aba "Configurações" — contato do admin, senha e disparo do resumo diário. */
const AdminConfig = ({ avisar }) => {
    const { admin } = useAuth();
    const [contato, setContato] = useState({ email: admin?.email || "", telefone: admin?.telefone || "" });
    const [senhas, setSenhas] = useState({ senha_atual: "", nova_senha: "" });
    const [erro, setErro] = useState(null);
    const [enviandoResumo, setEnviandoResumo] = useState(false);

    const salvarContato = async () => {
        setErro(null);
        try {
            await api.patch("/admin/contato", contato);
            avisar?.("Contato atualizado.");
        } catch (err) {
            setErro(err.response?.data?.error || "Não foi possível salvar o contato.");
        }
    };

    const trocarSenha = async (e) => {
        e.preventDefault();
        setErro(null);
        try {
            await api.put("/admin/senha", senhas);
            avisar?.("Senha alterada.");
            setSenhas({ senha_atual: "", nova_senha: "" });
        } catch (err) {
            setErro(err.response?.data?.error || "Não foi possível alterar a senha.");
        }
    };

    const dispararResumo = async () => {
        setEnviandoResumo(true);
        setErro(null);
        try {
            const { data } = await api.post("/admin/resumo-diario");
            avisar?.(data.message);
        } catch (err) {
            setErro(err.response?.data?.error || "Não foi possível disparar o resumo.");
        } finally {
            setEnviandoResumo(false);
        }
    };

    return (
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            {erro && <p className="erro">{erro}</p>}

            <Card>
                <h3 className="card-title">Meu contato</h3>
                <p className="card-body text-muted">E-mail e telefone do administrador do sistema.</p>
                <div className="grid-form">
                    <Field label="E-mail">
                        <Input type="email" value={contato.email} onChange={(e) => setContato((c) => ({ ...c, email: e.target.value }))} />
                    </Field>
                    <Field label="Telefone">
                        <Input value={contato.telefone} onChange={(e) => setContato((c) => ({ ...c, telefone: e.target.value }))} />
                    </Field>
                </div>
                <div style={{ marginTop: 8 }}><Button onClick={salvarContato}>Salvar contato</Button></div>
            </Card>

            <Card>
                <h3 className="card-title">Trocar senha</h3>
                <form onSubmit={trocarSenha} className="grid-form" style={{ alignItems: "end" }}>
                    <Field label="Senha atual">
                        <Input type="password" required autoComplete="current-password" value={senhas.senha_atual}
                            onChange={(e) => setSenhas({ ...senhas, senha_atual: e.target.value })} />
                    </Field>
                    <Field label="Nova senha (mín. 6)">
                        <Input type="password" required minLength={6} autoComplete="new-password" value={senhas.nova_senha}
                            onChange={(e) => setSenhas({ ...senhas, nova_senha: e.target.value })} />
                    </Field>
                    <div className="span-2"><Button type="submit">Salvar senha</Button></div>
                </form>
            </Card>

            <Card>
                <h3 className="card-title">Resumo diário</h3>
                <p className="card-body text-muted">Dispara agora os e-mails de resumo (normalmente enviados às 7h).</p>
                <div style={{ marginTop: 8 }}>
                    <Button variante="secondary" disabled={enviandoResumo} onClick={dispararResumo}>
                        {enviandoResumo ? "Enviando..." : "Disparar resumo diário"}
                    </Button>
                </div>
            </Card>
        </div>
    );
};

export default AdminConfig;
